import { Png } from "common/assets";

export const items = [
  {
    title: "Бензин",
    describe: "Ви отримуєте потужність та ефективність, які забезпечують комфортне та динамічне водіння. Пальне відповідає найвищим стандартам якості, що гарантує оптимальну роботу вашого двигуна.",
    src:`${Png.Petrol}`,
  },
  {
    title: "Газ",
    describe: "Ви отримуєте потужність та ефективність, які забезпечують комфортне та динамічне водіння. Пальне відповідає найвищим стандартам якості, що гарантує оптимальну роботу вашого двигуна.",
    src:`${Png.Gas}`,
  },
  {
    title: "ДП",
    describe: "Ви отримуєте потужність та ефективність, які забезпечують комфортне та динамічне водіння. Пальне відповідає найвищим стандартам якості, що гарантує оптимальну роботу вашого двигуна.",
    src:`${Png.Diesel}`,
  }
]